import { useTranslation } from 'react-i18next';
import z from 'zod';

export const useLoginFormValidationSchema = () => {
  const { t } = useTranslation();

  const emailStepValidationSchema = z.object({
    email: z
      .string()
      .min(1, t('validation:required'))
      .email(t('validation:email')),
  });

  const passwordStepValidationSchema = z.object({
    email: z
      .string()
      .min(1, t('validation:required'))
      .email(t('validation:email')),
    password: z.string().min(1, t('validation:required')),
  });

  const ssoProviderStepValidationSchema = z.object({
    email: z
      .string()
      .min(1, t('validation:required'))
      .email(t('validation:email')),
    ssoProviderId: z.string().min(1, t('validation:required')),
  });

  return {
    emailStepValidationSchema,
    passwordStepValidationSchema,
    ssoProviderStepValidationSchema,
  };
};

export type EmailStepFormValues = z.infer<
  ReturnType<typeof useLoginFormValidationSchema>['emailStepValidationSchema']
>;
export type PasswordStepFormValues = z.infer<
  ReturnType<
    typeof useLoginFormValidationSchema
  >['passwordStepValidationSchema']
>;
export type SSOProviderStepFormValues = z.infer<
  ReturnType<
    typeof useLoginFormValidationSchema
  >['ssoProviderStepValidationSchema']
>;
